export default{
    dateStringToNumber: function(str){
        var strArray = new Array();
        strArray = str.split(",");
        var returnStr = '';
        strArray.forEach(element => {
            returnStr+=element
        });
        return returnStr;
    }
}


// WEBPACK FOOTER //
// ./src/utils/stringUtil.js